import {
    createSlice
}
    from '@reduxjs/toolkit';

const initialState = {
    sortByText: "Last Updated Date",
    sortBy: 1,
    ascending: false,
    open: false,
    sortItems: [
        {
            text: "Last Updated Date",
            value: 1
        },
        {
            text: "Created Date",
            value: 2
        }
    ]
};

export const leadSorterSlice = createSlice({
    name: 'leadSorter',
    initialState,
    reducers: {
        updateAscending: (state, action) => {
            state.ascending = action.payload;
        },
        toggleMenu: (state, action) => {
            state.open = action.payload;
        },
        toggleAscending: (state, action) => {
            state.ascending = action.payload;
        },
        setSortItem: (state, action) => {
            const { sortByText, sortBy, open } = action.payload;
            state.sortByText = sortByText;
            state.sortBy = sortBy;
            state.open = open;
        },
        hideMenu: state => {
            state.open = false;
        }
    }
});

export const { updateAscending, setSortItem, toggleMenu, toggleAscending, hideMenu } = leadSorterSlice.actions;

export default leadSorterSlice.reducer

export const selectLeadSorterDetail = state => {
    return {
        sortByText: state.leadSorter.sortByText,
        sortBy: state.leadSorter.sortBy,
        ascending: state.leadSorter.ascending,
        open: state.leadSorter.open,
        sortByItems: state.leadSorter.sortItems
    }
}

export const selectSort = state => {
    return {
        by: state.leadSorter.sortBy,
        ascending: state.leadSorter.ascending
    }
};
